import { Box } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { LoadingOverlay } from '@/components/ui-shared/LoadingOverlay/LoadingOverlay'
import { useInvalidateDatasetQueries } from '@/queries/datasetQueries'
import { Dataset, DatasetVersion } from '@/types/dataset'
import {
  CLONE_PREFIX,
  DatasetForm,
  FormValues
} from '../DatasetForm/DatasetForm'
import { useCloneDatasetHandler } from './useCloneDatasetHandler'

type CloneDatasetHandlerProps = {
  originalDataset: Dataset
  originalDatasetVersion: DatasetVersion
  onCancel: () => void
  onDatasetCloned: (dataset: Dataset) => void
}

export const CloneDatasetHandler = ({
  originalDataset,
  originalDatasetVersion,
  onCancel,
  onDatasetCloned
}: CloneDatasetHandlerProps) => {
  const { cloneDataset, isPending } = useCloneDatasetHandler()
  const { invalidateDatasetList } = useInvalidateDatasetQueries()

  const handleCloneDataset = (values: FormValues) => {
    void cloneDataset(values, {
      onSuccess: (dataset) => {
        void invalidateDatasetList()
        onDatasetCloned(dataset)
      }
    })
  }

  return (
    <Box pos="relative">
      <LoadingOverlay
        visible={isPending}
        message={<FormattedMessage id="datasets.clone.pending" />}
      />

      <DatasetForm
        initialValues={{
          shouldCloneDataset: true,
          originalDataset,
          originalDatasetVersion,
          name: `${CLONE_PREFIX} ${originalDataset.name}`,
          datasetType: originalDataset.dataset_type,
          labelingType: originalDataset.labeling_type,
          labels: originalDataset.labels
        }}
        submitLabel={<FormattedMessage id="datasets.clone.button.label" />}
        isDatasetSelectDisabled
        withClone
        onCancel={onCancel}
        onSubmit={handleCloneDataset}
      />
    </Box>
  )
}
